"use client";

import { useSyncExternalStore } from "react";

import {
  getChatSignal,
  peekChatState,
  resolveChatRowStatus,
  type ChatRowStatus,
} from "@/features/chat/multi/signals/chat-signals";

export type { ChatRowStatus };

export type ChatRowFlags = {
  status: ChatRowStatus;
};

function getChatFlagsSnapshot(chatId: string): ChatRowStatus {
  return resolveChatRowStatus(peekChatState(chatId));
}

/** Per-chat exclusive status — only re-renders the row that changed. */
export function useChatRowFlags(chatId: string): ChatRowFlags {
  const status = useSyncExternalStore(
    (onChange) => getChatSignal(chatId).subscribe(onChange),
    () => getChatFlagsSnapshot(chatId),
    () => "idle" as ChatRowStatus,
  );
  return { status };
}
